import { render, staticRenderFns } from "./UncheckedAutomaticQuestionnaireAnswer.vue?vue&type=template&id=1c4973f7&scoped=true&"
import script from "./UncheckedAutomaticQuestionnaireAnswer.vue?vue&type=script&lang=ts&"
export * from "./UncheckedAutomaticQuestionnaireAnswer.vue?vue&type=script&lang=ts&"
import style0 from "./UncheckedAutomaticQuestionnaireAnswer.vue?vue&type=style&index=0&id=1c4973f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4973f7",
  null
  
)

export default component.exports